import script from "./PageHeaderIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeaderIcon.vue?vue&type=script&lang=ts&setup=true"

import "./PageHeaderIcon.vue?vue&type=style&index=0&id=69e94482&lang=scss&scoped=true"

import exportComponent from "/home/deploy/www/data/workspace/ads_tencn-prod/ads/src/grow-team-assist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e94482"]])

export default __exports__